// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   TEMPLATE EDITOR OVERLAY
========================================== */

.template-editor-overlay{
    position:fixed;
    inset:0;
    background:rgba(15,23,42,.75);
    backdrop-filter:blur(6px);
    display:flex;
    justify-content:center;
    align-items:center;
    z-index:99999;
}

/* ==========================================
   MAIN WINDOW
========================================== */

.template-editor{

    width:min(96vw,1700px);
    height:min(94vh,950px);

    background:#fff;

    border-radius:16px;

    overflow:hidden;

    display:grid;

    grid-template-columns:
        minmax(500px,2fr)
        240px
        380px;

    box-shadow:
        0 30px 80px rgba(0,0,0,.35);
}

/* ==========================================
   PREVIEW PANEL
========================================== */

.template-preview{

    background:#eef2f7;

    display:flex;

    justify-content:center;

    align-items:center;

    overflow:auto;

    padding:25px;

    border-right:1px solid #e5e7eb;
}

.template-preview canvas{

    border-radius:12px;

    box-shadow:
        0 15px 40px rgba(0,0,0,.15);

    background:white;
}

/* ==========================================
   LAYER PANEL
========================================== */

.layer-panel{

    display:flex;

    flex-direction:column;

    border-right:1px solid #e5e7eb;

    background:#fafafa;

    overflow:hidden;
}

.layer-header{

    padding:18px;

    border-bottom:1px solid #e5e7eb;

    font-size:22px;

    font-weight:700;
}

.layer-toolbar{

    padding:15px;
}

.layer-toolbar button{

    width:100%;

    height:46px;

    border:none;

    border-radius:10px;

    background:#2563eb;

    color:white;

    font-size:15px;

    font-weight:600;

    cursor:pointer;

    transition:.25s;
}

.layer-toolbar button:hover{

    background:#1d4ed8;
}

.layer-list{

    flex:1 1;

    overflow-y:auto;

    padding:12px;
}

.layer-item{

    padding:14px;

    margin-bottom:10px;

    border-radius:10px;

    background:white;

    border:1px solid #e5e7eb;

    cursor:pointer;

    transition:.2s;
}

.layer-item:hover{

    background:#f8fafc;
}

.layer-item.active{

    background:#2563eb;

    color:white;

    border-color:#2563eb;
}

/* ==========================================
   PROPERTY PANEL
========================================== */

.template-controls{

    display:flex;

    flex-direction:column;

    overflow:hidden;

    background:white;
}

.controls-header{

    padding:22px;

    border-bottom:1px solid #e5e7eb;

    font-size:30px;

    font-weight:700;

    color:#111827;
}

.controls-body{

    flex:1 1;

    overflow-y:auto;

    padding:22px;
}

.controls-footer{

    padding:18px;

    border-top:1px solid #e5e7eb;

    display:flex;

    gap:12px;

    background:white;
}

/* ==========================================
   HEADINGS
========================================== */

.template-controls h2{

    margin:0 0 25px;
}

.template-controls h3{

    margin-top:25px;

    margin-bottom:12px;

    color:#111827;

    font-size:18px;
}

/* ==========================================
   LABELS
========================================== */

.template-controls label{

    display:block;

    margin-top:15px;

    margin-bottom:6px;

    font-weight:600;

    color:#374151;
}

/* ==========================================
   INPUTS
========================================== */

.template-controls input[type=text],
.template-controls input[type=number],
.template-controls select{

    width:100%;

    padding:12px;

    border:1px solid #d1d5db;

    border-radius:10px;

    font-size:15px;

    transition:.2s;

    box-sizing:border-box;
}

.template-controls input:focus{

    outline:none;

    border-color:#2563eb;

    box-shadow:
        0 0 0 3px rgba(37,99,235,.15);
}

/* ==========================================
   RANGE
========================================== */

.template-controls input[type=range]{

    width:100%;

    margin-top:8px;

    margin-bottom:16px;
}

/* ==========================================
   CHECKBOX
========================================== */

.template-controls input[type=checkbox]{

    margin-right:8px;
}

/* ==========================================
   COLOR PICKER
========================================== */

.chrome-picker{

    width:100% !important;

    box-shadow:none !important;

    margin-top:12px;

    margin-bottom:18px;
}

/* ==========================================
   BUTTONS
========================================== */

.template-controls button{

    height:48px;

    border:none;

    border-radius:10px;

    font-size:15px;

    font-weight:600;

    cursor:pointer;

    transition:.25s;
}

.save-btn{

    flex:1 1;

    background:#2563eb;

    color:white;
}

.save-btn:hover{

    background:#1d4ed8;
}

.cancel-btn{

    width:140px;

    background:#f3f4f6;

    color:#111827;
}

.cancel-btn:hover{

    background:#e5e7eb;
}

.delete-btn{

    background:#ef4444;

    color:white;
}

.delete-btn:hover{

    background:#dc2626;
}

/* ==========================================
   SCROLLBAR
========================================== */

.controls-body::-webkit-scrollbar,
.layer-list::-webkit-scrollbar{

    width:8px;
}

.controls-body::-webkit-scrollbar-thumb,
.layer-list::-webkit-scrollbar-thumb{

    background:#d1d5db;

    border-radius:20px;
}

/* ==========================================
   TABLET
========================================== */

@media (max-width:1200px){

.template-editor{

grid-template-columns:
1fr
220px
320px;

}

}

/* ==========================================
   MOBILE
========================================== */

@media (max-width:900px){

.template-editor{

width:100vw;

height:100vh;

border-radius:0;

display:flex;

flex-direction:column;

}

.template-preview{

height:45vh;

padding:10px;

border-right:none;

border-bottom:1px solid #e5e7eb;

}

.layer-panel{

height:170px;

border-right:none;

border-bottom:1px solid #e5e7eb;

}

.layer-list{

display:flex;

overflow-x:auto;

overflow-y:hidden;

gap:10px;

padding:12px;

}

.layer-item{

min-width:150px;

margin-bottom:0;

}

.template-controls{

flex:1 1;

}

.controls-footer{

position:sticky;

bottom:0;

background:white;

}

}

/* ==========================================
   SMALL MOBILE
========================================== */

@media (max-width:600px){

.template-preview{

height:38vh;

}

.controls-header{

font-size:22px;

}

.template-controls{

font-size:14px;

}

}`, "",{"version":3,"sources":["webpack://./src/styles/TemplateEditor.css"],"names":[],"mappings":"AAAA;;4CAE4C;;AAE5C;IACI,cAAc;IACd,OAAO;IACP,6BAA6B;IAC7B,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;4CAE4C;;AAE5C;;IAEI,sBAAsB;IACtB,sBAAsB;;IAEtB,eAAe;;IAEf,kBAAkB;;IAElB,eAAe;;IAEf,YAAY;;IAEZ;;;aAGS;;IAET;mCAC+B;AACnC;;AAEA;;4CAE4C;;AAE5C;;IAEI,kBAAkB;;IAElB,YAAY;;IAEZ,sBAAsB;;IAEtB,kBAAkB;;IAElB,aAAa;;IAEb,YAAY;;IAEZ,8BAA8B;AAClC;;AAEA;;IAEI,kBAAkB;;IAElB;mCAC+B;;IAE/B,gBAAgB;AACpB;;AAEA;;4CAE4C;;AAE5C;;IAEI,YAAY;;IAEZ,qBAAqB;;IAErB,8BAA8B;;IAE9B,kBAAkB;;IAElB,eAAe;AACnB;;AAEA;;IAEI,YAAY;;IAEZ,+BAA+B;;IAE/B,cAAc;;IAEd,eAAe;AACnB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,UAAU;;IAEV,WAAW;;IAEX,WAAW;;IAEX,kBAAkB;;IAElB,kBAAkB;;IAElB,WAAW;;IAEX,cAAc;;IAEd,eAAe;;IAEf,cAAc;;IAEd,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,QAAM;;IAEN,eAAe;;IAEf,YAAY;AAChB;;AAEA;;IAEI,YAAY;;IAEZ,kBAAkB;;IAElB,kBAAkB;;IAElB,gBAAgB;;IAEhB,wBAAwB;;IAExB,cAAc;;IAEd,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;;IAElB,WAAW;;IAEX,oBAAoB;AACxB;;AAEA;;4CAE4C;;AAE5C;;IAEI,YAAY;;IAEZ,qBAAqB;;IAErB,eAAe;;IAEf,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;;IAEZ,+BAA+B;;IAE/B,cAAc;;IAEd,eAAe;;IAEf,aAAa;AACjB;;AAEA;;IAEI,QAAM;;IAEN,eAAe;;IAEf,YAAY;AAChB;;AAEA;;IAEI,YAAY;;IAEZ,4BAA4B;;IAE5B,YAAY;;IAEZ,QAAQ;;IAER,gBAAgB;AACpB;;AAEA;;4CAE4C;;AAE5C;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;;IAEf,kBAAkB;;IAElB,aAAa;;IAEb,cAAc;AAClB;;AAEA;;4CAE4C;;AAE5C;;IAEI,aAAa;;IAEb,eAAe;;IAEf,iBAAiB;;IAEjB,eAAe;;IAEf,aAAa;AACjB;;AAEA;;4CAE4C;;AAE5C;;;;IAII,UAAU;;IAEV,YAAY;;IAEZ,wBAAwB;;IAExB,kBAAkB;;IAElB,cAAc;;IAEd,cAAc;;IAEd,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;;IAEZ,oBAAoB;;IAEpB;qCACiC;AACrC;;AAEA;;4CAE4C;;AAE5C;;IAEI,UAAU;;IAEV,cAAc;;IAEd,kBAAkB;AACtB;;AAEA;;4CAE4C;;AAE5C;;IAEI,gBAAgB;AACpB;;AAEA;;4CAE4C;;AAE5C;;IAEI,qBAAqB;;IAErB,0BAA0B;;IAE1B,eAAe;;IAEf,kBAAkB;AACtB;;AAEA;;4CAE4C;;AAE5C;;IAEI,WAAW;;IAEX,WAAW;;IAEX,kBAAkB;;IAElB,cAAc;;IAEd,eAAe;;IAEf,cAAc;;IAEd,eAAe;AACnB;;AAEA;;IAEI,QAAM;;IAEN,kBAAkB;;IAElB,WAAW;AACf;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;;IAEX,kBAAkB;;IAElB,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;;IAElB,WAAW;AACf;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;4CAE4C;;AAE5C;;;IAGI,SAAS;AACb;;AAEA;;;IAGI,kBAAkB;;IAElB,kBAAkB;AACtB;;AAEA;;4CAE4C;;AAE5C;;AAEA;;AAEA;;;KAGK;;AAEL;;AAEA;;AAEA;;4CAE4C;;AAE5C;;AAEA;;AAEA,WAAW;;AAEX,YAAY;;AAEZ,eAAe;;AAEf,YAAY;;AAEZ,qBAAqB;;AAErB;;AAEA;;AAEA,WAAW;;AAEX,YAAY;;AAEZ,iBAAiB;;AAEjB,+BAA+B;;AAE/B;;AAEA;;AAEA,YAAY;;AAEZ,iBAAiB;;AAEjB,+BAA+B;;AAE/B;;AAEA;;AAEA,YAAY;;AAEZ,eAAe;;AAEf,iBAAiB;;AAEjB,QAAQ;;AAER,YAAY;;AAEZ;;AAEA;;AAEA,eAAe;;AAEf,eAAe;;AAEf;;AAEA;;AAEA,QAAM;;AAEN;;AAEA;;AAEA,eAAe;;AAEf,QAAQ;;AAER,gBAAgB;;AAEhB;;AAEA;;AAEA;;4CAE4C;;AAE5C;;AAEA;;AAEA,WAAW;;AAEX;;AAEA;;AAEA,cAAc;;AAEd;;AAEA;;AAEA,cAAc;;AAEd;;AAEA","sourcesContent":["/* ==========================================\n   TEMPLATE EDITOR OVERLAY\n========================================== */\n\n.template-editor-overlay{\n    position:fixed;\n    inset:0;\n    background:rgba(15,23,42,.75);\n    backdrop-filter:blur(6px);\n    display:flex;\n    justify-content:center;\n    align-items:center;\n    z-index:99999;\n}\n\n/* ==========================================\n   MAIN WINDOW\n========================================== */\n\n.template-editor{\n\n    width:min(96vw,1700px);\n    height:min(94vh,950px);\n\n    background:#fff;\n\n    border-radius:16px;\n\n    overflow:hidden;\n\n    display:grid;\n\n    grid-template-columns:\n        minmax(500px,2fr)\n        240px\n        380px;\n\n    box-shadow:\n        0 30px 80px rgba(0,0,0,.35);\n}\n\n/* ==========================================\n   PREVIEW PANEL\n========================================== */\n\n.template-preview{\n\n    background:#eef2f7;\n\n    display:flex;\n\n    justify-content:center;\n\n    align-items:center;\n\n    overflow:auto;\n\n    padding:25px;\n\n    border-right:1px solid #e5e7eb;\n}\n\n.template-preview canvas{\n\n    border-radius:12px;\n\n    box-shadow:\n        0 15px 40px rgba(0,0,0,.15);\n\n    background:white;\n}\n\n/* ==========================================\n   LAYER PANEL\n========================================== */\n\n.layer-panel{\n\n    display:flex;\n\n    flex-direction:column;\n\n    border-right:1px solid #e5e7eb;\n\n    background:#fafafa;\n\n    overflow:hidden;\n}\n\n.layer-header{\n\n    padding:18px;\n\n    border-bottom:1px solid #e5e7eb;\n\n    font-size:22px;\n\n    font-weight:700;\n}\n\n.layer-toolbar{\n\n    padding:15px;\n}\n\n.layer-toolbar button{\n\n    width:100%;\n\n    height:46px;\n\n    border:none;\n\n    border-radius:10px;\n\n    background:#2563eb;\n\n    color:white;\n\n    font-size:15px;\n\n    font-weight:600;\n\n    cursor:pointer;\n\n    transition:.25s;\n}\n\n.layer-toolbar button:hover{\n\n    background:#1d4ed8;\n}\n\n.layer-list{\n\n    flex:1;\n\n    overflow-y:auto;\n\n    padding:12px;\n}\n\n.layer-item{\n\n    padding:14px;\n\n    margin-bottom:10px;\n\n    border-radius:10px;\n\n    background:white;\n\n    border:1px solid #e5e7eb;\n\n    cursor:pointer;\n\n    transition:.2s;\n}\n\n.layer-item:hover{\n\n    background:#f8fafc;\n}\n\n.layer-item.active{\n\n    background:#2563eb;\n\n    color:white;\n\n    border-color:#2563eb;\n}\n\n/* ==========================================\n   PROPERTY PANEL\n========================================== */\n\n.template-controls{\n\n    display:flex;\n\n    flex-direction:column;\n\n    overflow:hidden;\n\n    background:white;\n}\n\n.controls-header{\n\n    padding:22px;\n\n    border-bottom:1px solid #e5e7eb;\n\n    font-size:30px;\n\n    font-weight:700;\n\n    color:#111827;\n}\n\n.controls-body{\n\n    flex:1;\n\n    overflow-y:auto;\n\n    padding:22px;\n}\n\n.controls-footer{\n\n    padding:18px;\n\n    border-top:1px solid #e5e7eb;\n\n    display:flex;\n\n    gap:12px;\n\n    background:white;\n}\n\n/* ==========================================\n   HEADINGS\n========================================== */\n\n.template-controls h2{\n\n    margin:0 0 25px;\n}\n\n.template-controls h3{\n\n    margin-top:25px;\n\n    margin-bottom:12px;\n\n    color:#111827;\n\n    font-size:18px;\n}\n\n/* ==========================================\n   LABELS\n========================================== */\n\n.template-controls label{\n\n    display:block;\n\n    margin-top:15px;\n\n    margin-bottom:6px;\n\n    font-weight:600;\n\n    color:#374151;\n}\n\n/* ==========================================\n   INPUTS\n========================================== */\n\n.template-controls input[type=text],\n.template-controls input[type=number],\n.template-controls select{\n\n    width:100%;\n\n    padding:12px;\n\n    border:1px solid #d1d5db;\n\n    border-radius:10px;\n\n    font-size:15px;\n\n    transition:.2s;\n\n    box-sizing:border-box;\n}\n\n.template-controls input:focus{\n\n    outline:none;\n\n    border-color:#2563eb;\n\n    box-shadow:\n        0 0 0 3px rgba(37,99,235,.15);\n}\n\n/* ==========================================\n   RANGE\n========================================== */\n\n.template-controls input[type=range]{\n\n    width:100%;\n\n    margin-top:8px;\n\n    margin-bottom:16px;\n}\n\n/* ==========================================\n   CHECKBOX\n========================================== */\n\n.template-controls input[type=checkbox]{\n\n    margin-right:8px;\n}\n\n/* ==========================================\n   COLOR PICKER\n========================================== */\n\n.chrome-picker{\n\n    width:100% !important;\n\n    box-shadow:none !important;\n\n    margin-top:12px;\n\n    margin-bottom:18px;\n}\n\n/* ==========================================\n   BUTTONS\n========================================== */\n\n.template-controls button{\n\n    height:48px;\n\n    border:none;\n\n    border-radius:10px;\n\n    font-size:15px;\n\n    font-weight:600;\n\n    cursor:pointer;\n\n    transition:.25s;\n}\n\n.save-btn{\n\n    flex:1;\n\n    background:#2563eb;\n\n    color:white;\n}\n\n.save-btn:hover{\n\n    background:#1d4ed8;\n}\n\n.cancel-btn{\n\n    width:140px;\n\n    background:#f3f4f6;\n\n    color:#111827;\n}\n\n.cancel-btn:hover{\n\n    background:#e5e7eb;\n}\n\n.delete-btn{\n\n    background:#ef4444;\n\n    color:white;\n}\n\n.delete-btn:hover{\n\n    background:#dc2626;\n}\n\n/* ==========================================\n   SCROLLBAR\n========================================== */\n\n.controls-body::-webkit-scrollbar,\n.layer-list::-webkit-scrollbar{\n\n    width:8px;\n}\n\n.controls-body::-webkit-scrollbar-thumb,\n.layer-list::-webkit-scrollbar-thumb{\n\n    background:#d1d5db;\n\n    border-radius:20px;\n}\n\n/* ==========================================\n   TABLET\n========================================== */\n\n@media (max-width:1200px){\n\n.template-editor{\n\ngrid-template-columns:\n1fr\n220px\n320px;\n\n}\n\n}\n\n/* ==========================================\n   MOBILE\n========================================== */\n\n@media (max-width:900px){\n\n.template-editor{\n\nwidth:100vw;\n\nheight:100vh;\n\nborder-radius:0;\n\ndisplay:flex;\n\nflex-direction:column;\n\n}\n\n.template-preview{\n\nheight:45vh;\n\npadding:10px;\n\nborder-right:none;\n\nborder-bottom:1px solid #e5e7eb;\n\n}\n\n.layer-panel{\n\nheight:170px;\n\nborder-right:none;\n\nborder-bottom:1px solid #e5e7eb;\n\n}\n\n.layer-list{\n\ndisplay:flex;\n\noverflow-x:auto;\n\noverflow-y:hidden;\n\ngap:10px;\n\npadding:12px;\n\n}\n\n.layer-item{\n\nmin-width:150px;\n\nmargin-bottom:0;\n\n}\n\n.template-controls{\n\nflex:1;\n\n}\n\n.controls-footer{\n\nposition:sticky;\n\nbottom:0;\n\nbackground:white;\n\n}\n\n}\n\n/* ==========================================\n   SMALL MOBILE\n========================================== */\n\n@media (max-width:600px){\n\n.template-preview{\n\nheight:38vh;\n\n}\n\n.controls-header{\n\nfont-size:22px;\n\n}\n\n.template-controls{\n\nfont-size:14px;\n\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
